import { c as _c } from "react/compiler-runtime";
import { useSelectedTag } from "@/store/dpStore";
import DoneIcon from "@mui/icons-material/Done";
import { Chip, Skeleton } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import { useRef } from "react";
import { fetchProjectMediaGalleries } from "../api";
import AutoAwesomeOutlinedIcon from "@mui/icons-material/AutoAwesomeOutlined";
import { useSearchParams } from "next/navigation";
import { useUrlParams } from "../../_hooks/useUrlParams";
import { colorPrimaryPrimary } from "@/app/(styles)/variables";
import { inhomzEvents } from "@/app/(fevicol-inhomz)/_lib/events";
import { profileEventProps } from "@/app/(fevicol-inhomz)/_lib/profileEventProps";
import { useInhomzTrack } from "@/app/(fevicol-inhomz)/_hooks/useInhomzTrack";
const DEFAULT_SORT = "image_score";
const SORT_LABELS = {
  image_score: "Relevance",
  createdAt: "Date added"
};
export default function GalleryFilters(t0) {
  const $ = _c(35);
  const {
    digitalProfile,
    isPreviewLeadGenProfile
  } = t0;
  const searchParams = useSearchParams();
  const {
    updateParams
  } = useUrlParams();
  const {
    selectedTag,
    setSelectedTag
  } = useSelectedTag();
  const chipsScrollref = useRef(null);
  const track = useInhomzTrack();
  let t1;
  if ($[0] !== searchParams) {
    t1 = searchParams.get("sortBy") ?? DEFAULT_SORT;
    $[0] = searchParams;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const sortBy = t1;
  const t2 = digitalProfile?.id;
  let t3;
  if ($[2] !== selectedTag || $[3] !== sortBy || $[4] !== t2) {
    t3 = ["project-media-galleries", t2, selectedTag, sortBy];
    $[2] = selectedTag;
    $[3] = sortBy;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== digitalProfile || $[7] !== selectedTag || $[8] !== sortBy) {
    t4 = () => fetchProjectMediaGalleries({
      id: digitalProfile.id,
      selectedTag,
      sortBy: sortBy ?? DEFAULT_SORT
    });
    $[6] = digitalProfile;
    $[7] = selectedTag;
    $[8] = sortBy;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const t5 = !!digitalProfile?.id;
  let t6;
  if ($[10] !== t3 || $[11] !== t4 || $[12] !== t5) {
    t6 = {
      queryKey: t3,
      queryFn: t4,
      enabled: t5
    };
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  const {
    data: projectImages,
    isLoading
  } = useQuery(t6);
  let t7;
  if ($[14] !== projectImages) {
    t7 = () => {
      let filters = [{
        tag: "All",
        tag_display_name: "All"
      }];
      if (projectImages && projectImages?.tag_id_filters && projectImages?.tag_id_filters.length > 0) {
        filters = [...filters, ...projectImages?.tag_id_filters.filter(_temp)];
      }
      return filters;
    };
    $[14] = projectImages;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  const configureFilters = t7;
  let t8;
  if ($[16] !== digitalProfile || $[17] !== selectedTag || $[18] !== setSelectedTag || $[19] !== track) {
    t8 = (tag, label) => {
      if (tag !== selectedTag) {
        track(inhomzEvents.contractorProfile.FILTER_CHIP_CLICKED, {
          ...profileEventProps(digitalProfile),
          event_value: label
        });
      }
      setSelectedTag(tag);
    };
    $[16] = digitalProfile;
    $[17] = selectedTag;
    $[18] = setSelectedTag;
    $[19] = track;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  const handleChipClick = t8;
  let t9;
  if ($[21] !== sortBy || $[22] !== updateParams) {
    t9 = () => {
      const next = sortBy === "image_score" ? "createdAt" : "image_score";
      updateParams({
        sortBy: next === DEFAULT_SORT ? null : next
      });
    };
    $[21] = sortBy;
    $[22] = updateParams;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  const handleSortToggle = t9;
  const hasFiltersOrData = projectImages?.tag_id_filters?.length > 0 || projectImages?.data?.length > 0;
  if (isLoading) {
    let t10;
    if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
      t10 = <div className="mx-auto px-0 w-full sticky top-0 bg-white z-10 py-3 flex flex-col min-w-0"><div className="px-4 md:px-4 flex flex-nowrap overflow-x-hidden gap-2 w-full min-w-0">{[60, 72, 65, 80].map(_temp2)}</div></div>;
      $[24] = t10;
    } else {
      t10 = $[24];
    }
    return t10;
  }
  let t10;
  if ($[25] !== configureFilters || $[26] !== handleChipClick || $[27] !== handleSortToggle || $[28] !== hasFiltersOrData || $[29] !== isPreviewLeadGenProfile || $[30] !== selectedTag || $[31] !== sortBy) {
    t10 = hasFiltersOrData && <div className={`mx-auto px-0 w-full sticky ${isPreviewLeadGenProfile ? "top-[45px]" : "top-[108px]"} md:top-[45px] bg-white z-10 py-3 flex min-w-0`}><div className="px-2 md:px-2 flex flex-nowrap overflow-x-scroll no-scrollbar w-full min-w-0" ref={chipsScrollref}><Chip clickable={true} icon={<AutoAwesomeOutlinedIcon sx={{
          fontSize: 16.5,
          color: colorPrimaryPrimary + " !important"
        }} />} label={SORT_LABELS[sortBy] ?? SORT_LABELS[DEFAULT_SORT]} variant="outlined" onClick={handleSortToggle} className="font-medium m3-label-large text-[14px] shrink-0" sx={{
          height: "auto",
          bgcolor: "#ffffff",
          color: "#1B1C17",
          borderRadius: "100px",
          borderColor: "var(--colorOutlineOutline, #aeb7f9)",
          padding: "6px 16px 6px 8px",
          marginRight: 1,
          "& .MuiChip-icon": {
            margin: 0,
            marginLeft: 0
          },
          "& .MuiChip-label": {
            padding: 0,
            paddingLeft: "8px"
          }
        }} />{configureFilters()?.map(t11 => {
          const {
            tag: tag_0,
            tag_display_name
          } = t11;
          return <Chip clickable={true} icon={tag_0 === selectedTag ? <DoneIcon fontSize="small" /> : null} label={tag_display_name} key={tag_0} variant="outlined" onClick={() => handleChipClick(tag_0, tag_display_name)} className="capitalize font-medium m3-label-large text-[14px]" style={{
            backgroundColor: tag_0 === selectedTag ? "#DEE1F9" : "#ffffff",
            color: tag_0 === selectedTag ? "#1B1C17" : "#5E5F59",
            marginRight: 8,
            borderColor: tag_0 === selectedTag ? "transparent" : "#5A5D72",
            borderRadius: tag_0 === selectedTag ? "100px" : "8px"
          }} />;
        })}</div></div>;
    $[25] = configureFilters;
    $[26] = handleChipClick;
    $[27] = handleSortToggle;
    $[28] = hasFiltersOrData;
    $[29] = isPreviewLeadGenProfile;
    $[30] = selectedTag;
    $[31] = sortBy;
    $[32] = t10;
  } else {
    t10 = $[32];
  }
  let t11;
  if ($[33] !== t10) {
    t11 = <>{t10}</>;
    $[33] = t10;
    $[34] = t11;
  } else {
    t11 = $[34];
  }
  return t11;
}
function _temp2(w, i) {
  return <Skeleton key={i} variant="rounded" width={w} height={32} sx={{
    flexShrink: 0,
    borderRadius: "8px"
  }} />;
}
function _temp(item) {
  return item?.tag !== "all";
}